
import { useState, useEffect } from 'react';
import { User } from '@/types/userRole';

export const useUsers = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    setIsLoading(true);
    try {
      // Mock data for now - replace with actual API call
      const mockUsers: User[] = [
        { id: '1', name: 'John Doe', email: 'john@example.com', role: 'admin' },
        { id: '2', name: 'Jane Smith', email: 'jane@example.com', role: 'manager' },
        { id: '3', name: 'Bob Wilson', email: 'bob@example.com', role: 'user' },
      ];
      setUsers(mockUsers);
    } catch (error) {
      console.error('Error loading users:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const inviteUser = async (data: { email: string; role: string; name: string }) => {
    // Mock invite functionality - replace with actual API call
    const newUser: User = {
      id: Date.now().toString(),
      name: data.name,
      email: data.email,
      role: data.role as any,
    };
    setUsers([...users, newUser]);
  };

  const removeUser = async (userId: string) => {
    // Mock remove functionality - replace with actual API call
    setUsers(users.filter(user => user.id !== userId));
  };

  return {
    users,
    isLoading,
    inviteUser,
    removeUser,
  };
};
